import { createFileRoute } from '@tanstack/react-router';

import { Reporting, ReportingSearchParamsSchema } from '@/features/reporting';

export const Route = createFileRoute('/_app/reporting')({
  validateSearch: ReportingSearchParamsSchema,
  component: RouteComponent,
});

function RouteComponent() {
  return <Reporting />;
}
